
import { Component, Prop, Vue } from 'vue-property-decorator'
import { RadioButtonLabelPosition } from '@/commons/constants/radio.button'

@Component
export default class SelectBoxRounded extends Vue {
    isFocusIndicator = false

    @Prop() setter!: (value: unknown) => void
    @Prop() buttonGroup!: string
    @Prop({ default: true }) showLabel!: boolean
    @Prop({ default: '' }) translationKey!: string
    @Prop({ default: '' }) fallbackLabelText!: string
    @Prop() modelReference!: string | number | boolean
    @Prop({ default: true }) radioButtonValue!: string | number | boolean
    @Prop({ default: RadioButtonLabelPosition.RIGHT }) labelPosition!: string

    get picked (): string | number | boolean {
        return this.modelReference
    }

    set picked (value: string | number | boolean) {
        this.setter(value)
    }

    get isLabelOnLeft (): boolean {
        return this.isLabelShown && this.labelPosition === RadioButtonLabelPosition.LEFT
    }

    get isLabelOnRight (): boolean {
        return this.isLabelShown && this.labelPosition === RadioButtonLabelPosition.RIGHT
    }

    get isLabelShown (): boolean {
        return !!(this.showLabel && this.labelText)
    }

    get labelText (): string {
        if (this.translationKey && this.$te(this.translationKey)) {
            return this.$t(this.translationKey).toString()
        }
        return this.fallbackLabelText
    }

    onClick (): void {
        this.onBlur()
    }

    onBlur (): void {
        this.isFocusIndicator = false
    }

    onKeyUp (): void {
        this.isFocusIndicator = true
    }
}
